import React, { useEffect, useState, useRef, Fragment } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import XLSX from 'xlsx'
import { useReactToPrint } from 'react-to-print'

import Rightbar from 'pages/main/cheques/Rightbar'
import PeriodPicker from 'pages/parts/PeriodPicker'
import { httpOk, GET } from 'helpers/api'
import MotivationProgramsTable from 'pages/parts/MotivationProgramsTable'
import { formatMoney, formatDate, returnSign, findKeyFromArrayByValue } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"
import { renderMenuTreeRows, flattenMenuGroups, reportApiType } from 'pages/parts/menuTreeRows'
import { businessToday } from 'helpers/businessDay'

const THERMAL_PRINT_PAGE_STYLE = `
	@page {
		size: 80mm auto;
		margin: 2mm;
	}
	@media print {
		body {
			margin: 0;
			font-family: Arial, Helvetica, sans-serif;
			color: #000;
			-webkit-print-color-adjust: exact;
			print-color-adjust: exact;
		}
		.shift-thermal-print,
		.shift-thermal-print * {
			color: #000 !important;
			overflow: visible !important;
			height: auto !important;
			max-height: none !important;
		}
		.shift-thermal-print {
			width: 80mm !important;
			line-height: 1.25 !important;
		}
		.d-print-none {
			display: none !important;
		}
	}
`

function Index() {
	const { t } = useTranslation()
	const printRef = useRef()
	const [printedAt, setPrintedAt] = useState(null)

	const reduxAccount = useSelector(state => state.account)

	const [reports] = useState([
		{ 'value': 'x_report', 'name': `X ${t('report')}` },
		{ 'value': 'menus', 'name': `${t('menu')}` },
		{ 'value': 'products', 'name': `${t('products')}` },
		{ 'value': 'preparation_places', 'name': `${t('preparation_places')}` },
		{ 'value': 'deleted_cheques', 'name': `${t('deleted_cheques')}` },
		{ 'value': 'deleted_products', 'name': `${t('deleted_products')}` },
		{ 'value': 'discount_cheques', 'name': `${t('discount_cheques')}` },
		{ 'value': 'order_types', 'name': `${t('order_types')}` },
		{ 'value': 'order_sub_types', 'name': `${t('delivery_types')}` },
		{ 'value': 'payment_types', 'name': `${t('payment_types')}` },
		{ 'value': 'expenses', 'name': `${t('take_money')}` },
		{ 'value': 'incomes', 'name': `${t('put_money')}` },
		{ 'value': 'clients', 'name': `${t('clients')}` },
		{ 'value': 'debtors', 'name': `${t('debtors')}` },
		{ 'value': 'motivation_programs', 'name': `${t('motivation_programs')}` },
		{ 'value': 'waiters', 'name': `${t('waiters_summary')}` },
		{ 'value': 'waiter_menus', 'name': `${t('waiters_menus')}` },
		{ 'value': 'waiter_products', 'name': `${t('waiter_products')}` },
		{ 'value': 'cashiers', 'name': `${t('cashiers_summary')}` },
		{ 'value': 'cashiers_x', 'name': `${t('cashiers_details')}` },
		{ 'value': 'couriers', 'name': `${t('couriers')}` },
		{ 'value': 'ingredients', 'name': `${t('ingredients')}` },
		{ 'value': 'products_ingredients', 'name': `${t('products_ingredients')}` },
	]);

	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState(false)
	const [activeTab, setActiveTab] = useState('x_report')
	const [activeCashierLogin, setActiveCashierLogin] = useState('')
	const [expandedItems, setExpandedItems] = useState({})
	const [xReportData, setXreportData] = useState({
		"reports": {},
		"x_report": {},
		"menus": {},
		"products": {},
		"preparation_places": {},
		"deleted_cheques": {},
		"deleted_products": {},
		"discount_cheques": {},
		"order_types": {},
		"order_sub_types": {},
		"payment_types": {},
		"expenses": {},
		"incomes": {},
		"clients": {},
		"debtors": {},
		"motivation_programs": {},
		"waiters": {},
		"waiters_menus": {},
		"waiter_products": {},
		"cashiers": {},
		"cashiers_x": {},
		"couriers": {},
		"ingredients": {},
		"products_ingredients": {},
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		'start_date': businessToday(),
		'end_date': businessToday(),
		'pos_id': reduxAccount.pos_id,
	})

	async function searchWithFilter(type = 'x_report') {
		var filterUrl = `/report-z`
		var urlParams = ""

		if (type)
			urlParams += returnSign(urlParams) + 'type=' + reportApiType(type)
		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date
		// Детализация бонуса приходит в том же ответе (по меню, продукты внутри) — второго запроса по клику нет
		if (type === 'motivation_programs')
			urlParams += returnSign(urlParams) + 'with_items=menu'

		if (`/report-z${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			var xReportDataCopy = { ...xReportData }

			if (type === 'x_report') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'menus') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'preparation_places') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'deleted_cheques') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'deleted_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'discount_cheques') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_sub_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'payment_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'expenses') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'incomes') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'clients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'debtors') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'motivation_programs') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiters') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiter_menus') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiter_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers_x') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
				const list = Array.isArray(response.data)
					? response.data
					: (Array.isArray(response.data?.data) ? response.data.data : [])
				if (list.length > 0) {
					const stillExists = list.some((c) => c.cashier_login === activeCashierLogin)
					if (!stillExists) setActiveCashierLogin(list[0].cashier_login)
				}
			}
			if (type === 'couriers') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products_ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}

			setActiveTab(type)
			setDropdownIsOpen(false)
			return response.data
		}

		setActiveTab(type)
		setDropdownIsOpen(false)
		return null
	}

	function writeExcelFile(rows, sheetName, fileName) {
		const wb = XLSX.utils.book_new()
		const ws = XLSX.utils.aoa_to_sheet(rows)
		const safeSheet = String(sheetName || 'Sheet1').slice(0, 31)
		XLSX.utils.book_append_sheet(wb, ws, safeSheet)
		XLSX.writeFile(wb, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`)
	}

	function flattenProductIngredients(items, level = 0, rows = [], counter = { n: 0 }) {
		;(items || []).forEach((item) => {
			if (!item.parent_id) counter.n += 1
			rows.push([
				item.parent_id ? '' : counter.n,
				`${'  '.repeat(level)}${item.name || ''}`,
				item.category_name || '',
				item.unit_name || '',
				Number(item.total_quantity) || 0,
			])
			if (item.children?.length) {
				flattenProductIngredients(item.children, level + 1, rows, counter)
			}
		})
		return rows
	}

	function getExcelDateSuffix() {
		return `${filterData.start_date || ''}_${filterData.end_date || ''}`
	}

	function exportXReportExcel(reportParam) {
		const report = reportParam || xReportData?.x_report
		if (!report || (!report.count_cheques && report.count_cheques !== 0 && !report.payments)) return

		const rows = [
			[`${t('number_of_checks')} [ ${t('hall')} ]`, Number(report.count_hall) || 0],
			[`${t('number_of_checks')} [ ${t('takeaway')} ]`, Number(report.count_takeaway) || 0],
			[`${t('number_of_checks')} [ ${t('delivery')} ]`, Number(report.count_delivery) || 0],
			[t('number_of_checks'), Number(report.count_cheques) || 0],
		]

		if (report.count_deleted_cheques) {
			rows.push([t('deleted_cheques'), Number(report.count_deleted_cheques) || 0])
			rows.push([t('deleted_products'), Number(report.count_deleted_products) || 0])
		}

		rows.push([])
		rows.push([t('sales'), Number(report.sales) || 0])
		rows.push([t('service'), Number(report.service_percentage_amount) || 0])
		rows.push([t('delivery'), Number(report.total_delivery_amount) || 0])
		rows.push([t('sales_amount'), Number(report.total_sales) || 0])
		rows.push([t('discount'), Number(report.total_discount) || 0])
		rows.push([t('debt'), Number(report.total_debt_amount) || 0])
		if (report.loyalty) {
			rows.push([t('loyalty'), Number(report.loyalty) || 0])
		}
		rows.push([
			t('total'),
			(Number(report.total_discount) || 0) + (Number(report.total_debt_amount) || 0),
		])
		rows.push([t('total_checkout'), Number(report.total_payments) || 0])
		rows.push([])

		;(report.payments || []).forEach((item) => {
			const name = [item.payment_type_name, item.payment_purpose_name]
				.filter(Boolean)
				.join(' ')
			const amount = Number(item.amount) || 0
			rows.push([
				name,
				item.transaction_type === 'minus' ? -Math.abs(amount) : amount,
			])
		})

		if (report.total_cash) {
			rows.push([t('total_cash'), Number(report.total_cash) || 0])
		}
		if (report.total_bank) {
			rows.push([t('total_bank'), Number(report.total_bank) || 0])
		}
		if (report.total_expense) {
			rows.push([t('total_expense'), Number(report.total_expense) || 0])
		}

		rows.push([])
		rows.push([t('cashbox_balance'), Number(report.balance) || 0])

		writeExcelFile(rows, `X ${t('report')}`, `X_${t('report')}_${getExcelDateSuffix()}`)
	}

	function buildTabExcelRows(type, payload) {
		const title = reports.find((r) => r.value === type)?.name || type
		const fileName = `${title}_${getExcelDateSuffix()}`

		const tableItems = (rowsType, data) => rowsType === 'menus' ? flattenMenuGroups(data) : (data || [])

		if (type === 'menus' || type === 'preparation_places' || type === 'order_types'
			|| type === 'order_sub_types' || type === 'payment_types' || type === 'clients'
			|| type === 'cashiers' || type === 'couriers') {
			// заголовок первой колонки такой же, как в таблице на экране
			const nameColumns = {
				'menus': t('menu'),
				'preparation_places': t('preparation_places'),
				'order_types': t('order_type'),
				'order_sub_types': t('delivery_type'),
				'clients': t('client'),
				'cashiers': t('cashier'),
				'couriers': t('courier'),
			}
			const rows = [[nameColumns[type] || t('name2'), t('quantity'), t('amount')]]
			;tableItems(type, payload?.data).forEach((item) => {
				rows.push([
					item.name || '',
					Number(item.total_quantity) || 0,
					Number(item.total_amount) || 0,
				])
			})
			rows.push([
				t('total'),
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'products') {
			const rows = [[t('menu'), t('product'), t('quantity'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.menu_name || '',
					item.name || '',
					Number(item.total_quantity) || 0,
					Number(item.total_amount) || 0,
				])
			})
			rows.push([
				t('total'),
				'',
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'deleted_cheques') {
			const rows = [['#', t('cashier'), t('waiter'), t('time'), '№', t('amount')]]
			;(payload?.data || []).forEach((item, index) => {
				rows.push([
					index + 1,
					item.cashier_name || '',
					item.waiter_name || '',
					item.cheque_closed_at ? formatDate(item.cheque_closed_at, 'HH:mm') : '',
					item.cheque_number || '',
					Number(item.total_amount) || 0,
				])
			})
			rows.push(['', t('total'), '', '', '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'discount_cheques') {
			const rows = [['#', t('cashier'), t('waiter'), t('time'), '№', t('discount'), t('amount')]]
			;(payload?.data || []).forEach((item, index) => {
				rows.push([
					index + 1,
					item.cashier_name || '',
					item.waiter_name || '',
					item.cheque_closed_at ? formatDate(item.cheque_closed_at, 'HH:mm') : '',
					item.cheque_number || '',
					Number(item.discount) || 0,
					Number(item.total_amount) || 0,
				])
			})
			rows.push([
				'',
				t('total'),
				'',
				'',
				'',
				Number(payload?.total_discount) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'deleted_products') {
			const rows = [[t('name2'), t('time'), '№', t('quantity'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.name || '',
					item.created_at ? formatDate(item.created_at, 'HH:mm') : '',
					item.cheque_number || '',
					Number(item.quantity) || 0,
					Number(item.total_price) || 0,
				])
			})
			rows.push([
				t('total'),
				'',
				'',
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'expenses') {
			const rows = [[t('type'), t('counterparty'), t('note'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.name || '',
					item.counterparty || '',
					item.note || '',
					Number(item.amount) || 0,
				])
			})
			rows.push([t('total'), '', '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'incomes') {
			const rows = [[t('type'), t('counterparty'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.name || '',
					item.counterparty || '',
					Number(item.amount) || 0,
				])
			})
			rows.push([t('total'), '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'debtors') {
			const rows = [[t('client'), t('counterparty'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.name || '',
					returnEntityType(item),
					Number(item.total_amount) || 0,
				])
			})
			rows.push([t('total'), '', Number(payload?.total_amount) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'waiters') {
			const rows = [[t('waiter'), t('quantity'), t('service'), t('amount')]]
			;(payload?.data || []).forEach((item) => {
				rows.push([
					item.name || '',
					Number(item.total_quantity) || 0,
					Number(item.total_service_amount) || 0,
					Number(item.total_amount) || 0,
				])
			})
			rows.push([
				t('total'),
				Number(payload?.total_quantity) || 0,
				Number(payload?.total_service_amount) || 0,
				Number(payload?.total_amount) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'waiter_menus' || type === 'waiter_products') {
			const childKey = type === 'waiter_menus' ? 'menus' : 'products'
			const rows = [[t('waiter'), t('name2'), t('quantity'), t('amount')]]
			;(payload?.data || []).forEach((waiter) => {
				;(type === 'waiter_menus' ? flattenMenuGroups(waiter?.groups) : (waiter?.[childKey] || [])).forEach((item) => {
					rows.push([
						waiter.name || '',
						item.name || '',
						Number(item.total_quantity) || 0,
						Number(item.total_amount) || 0,
					])
				})
				rows.push([
					waiter.name || '',
					t('total'),
					Number(waiter.total_quantity) || 0,
					Number(waiter.total_amount) || 0,
				])
				rows.push(['', '', '', ''])
			})
			return { rows, sheetName: title, fileName }
		}


		if (type === 'motivation_programs') {
			const motivationData = getMotivationProgramRows(payload)
			const rows = [[t('employee'), t('name2'), t('amount'), t('bonus')]]
			motivationData.rows.forEach((item) => {
				rows.push([
					item.program_name || '',
					item.employee_name || '',
					Number(item.sales) || 0,
					Number(item.bonus) || 0,
				])
			})
			rows.push([
				t('total'),
				'',
				Number(motivationData.totalSales) || 0,
				Number(motivationData.totalBonus) || 0,
			])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'ingredients') {
			const rows = [['#', t('element'), t('category'), t('unit'), t('quantity')]]
			;(payload?.data || []).forEach((item, index) => {
				rows.push([
					index + 1,
					item.name || '',
					item.category_name || '',
					item.unit_name || '',
					Number(item.total_quantity) || 0,
				])
			})
			rows.push(['', t('total'), '', '', Number(payload?.total_quantity) || 0])
			return { rows, sheetName: title, fileName }
		}

		if (type === 'products_ingredients') {
			const rows = [['#', t('product'), t('category'), t('unit'), t('quantity')]]
			flattenProductIngredients(payload?.data || [], 0, rows)
			return { rows, sheetName: title, fileName }
		}

		return null
	}

	async function exportTabExcel(type, e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()

		if (type === 'cashiers_x') {
			await exportCashiersPaymentsExcel(e)
			return
		}

		if (type === 'x_report') {
			let report = xReportData?.x_report
			const hasReport = report && (report.count_cheques != null || report.payments)
			if (!hasReport) {
				report = await searchWithFilter(type)
			}
			exportXReportExcel(report)
			return
		}

		let payload = xReportData?.[type]
		const hasData = type === 'motivation_programs'
			? (Array.isArray(payload?.data) || Array.isArray(payload?.motivation_programs))
			: Array.isArray(payload?.data)
		if (!hasData) {
			payload = await searchWithFilter(type)
		}

		const built = buildTabExcelRows(type, payload)
		if (!built?.rows?.length) return
		writeExcelFile(built.rows, built.sheetName, built.fileName)
	}

	async function exportCashiersPaymentsExcel(e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()

		let payload = xReportData?.cashiers_x
		if (!payload?.excel_rows && !payload?.data) {
			const filterUrl = `/report-z?type=cashiers_x&pos_id=${filterData.pos_id}&start_date=${filterData.start_date}&end_date=${filterData.end_date}`
			const response = await GET(filterUrl, {}, { loader: true })
			if (!httpOk(response)) return
			payload = response.data
			setXreportData({ ...xReportData, cashiers_x: response.data })
			setActiveTab('cashiers_x')
			const list = Array.isArray(response.data?.data) ? response.data.data : []
			if (list.length > 0) setActiveCashierLogin(list[0].cashier_login)
		}

		const rows = Array.isArray(payload?.excel_rows) ? payload.excel_rows : []
		const excelRows = [[
			t('cashier'),
			t('name2'),
			t('quantity'),
			t('amount'),
		]]

		let totalQty = 0
		let totalAmount = 0
		let prevCashier = null
		let cashierQty = 0
		let cashierAmount = 0

		const pushCashierTotal = () => {
			if (prevCashier === null) return
			excelRows.push([prevCashier, t('total'), cashierQty, cashierAmount])
			excelRows.push(['', '', '', ''])
		}

		rows.forEach((row) => {
			const cashierName = row.cashier_name || row.cashier_login || ''
			if (prevCashier !== null && prevCashier !== cashierName) {
				pushCashierTotal()
				cashierQty = 0
				cashierAmount = 0
			}
			prevCashier = cashierName
			const qty = Number(row.total_quantity) || 0
			const amount = Number(row.total_amount) || 0
			cashierQty += qty
			cashierAmount += amount
			totalQty += qty
			totalAmount += amount
			excelRows.push([cashierName, row.name || '', qty, amount])
		})
		pushCashierTotal()
		excelRows.push([t('total'), '', totalQty, totalAmount])

		const wb = XLSX.utils.book_new()
		const ws = XLSX.utils.aoa_to_sheet(excelRows)
		ws['!cols'] = [{ wch: 40 }, { wch: 28 }, { wch: 12 }, { wch: 18 }]
		XLSX.utils.book_append_sheet(wb, ws, t('payment_types') || 'payment_types')
		XLSX.writeFile(
			wb,
			`${t('cashiers_details')}_${filterData.start_date}_${filterData.end_date}.xlsx`
		)
	}

	function getCashiersXList() {
		const raw = xReportData?.cashiers_x
		if (Array.isArray(raw)) return raw
		if (Array.isArray(raw?.data)) return raw.data
		return []
	}

	function getActiveCashierX() {
		const list = getCashiersXList()
		if (!list.length) return null
		return list.find((item) => item.cashier_login === activeCashierLogin) || list[0]
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function toggleRightbar(boolean = false, item) {
		if (boolean) {
			const response = await GET(`/cheques/${item.cheque_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data.data)
				setShowRightBar(boolean)
			}

		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	function returnEntityType(item) {
		var name = ''
		if (item?.counterparty === 'supplier') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'client') {
			name = t('client')
		}

		return name
	}

	function getMotivationProgramRows(payload = {}) {
		const programs = Array.isArray(payload?.data)
			? payload.data
			: (Array.isArray(payload?.motivation_programs) ? payload.motivation_programs : [])
		const rows = []
		let totalSales = 0
		let totalBonus = 0

		programs.forEach((program) => {
			const users = Array.isArray(program?.users) ? program.users : []
			users.forEach((user) => {
				const sales = Number(user?.sales) || 0
				const bonus = Number(user?.bonus) || 0
				totalSales += sales
				totalBonus += bonus
				rows.push({
					program_name: program?.name ?? '',
					employee_name: user?.name ?? '',
					sales,
					bonus,
				})
			})
		})

		return { rows, totalSales, totalBonus }
	}

	function TreeTable({ data, level = 0, formatMoney }) {
		return (
			<>
				{data?.map((item, index) => (
					<Fragment key={item.product_id}>
						<tr>
							<td className="text-center">
								{!item.parent_id &&
									<span>{index + 1}</span>
								}
							</td>
							<td style={{ 'paddingLeft': `${level * 10 + 10}px` }}
								onClick={(e) => {
									e.stopPropagation()
									toggleExpand(item.product_id)
								}}>
								{!item.parent_id &&
									<span className={item?.children?.length ? `product-parent` : ''}>{item.name}</span>
								}
								{item.parent_id &&
									<i className={item?.children?.length ? `product-parent` : ''}>{item.name}</i>
								}
							</td>
							<td>{item.category_name}</td>
							<td>{item.unit_name}</td>
							<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
						</tr>
						{expandedItems[item.product_id] && item.children && item.children.length > 0 && (
							<TreeTable
								data={item.children}
								level={level + 1}
								formatMoney={formatMoney}
							/>
						)}
					</Fragment>
				))}
			</>
		)
	}

	const toggleExpand = (product_id) => {
		setExpandedItems((prev) => ({
			...prev,
			[product_id]: !prev[product_id],
		}))
	}

	useEffect(() => {
		searchWithFilter()
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
		pageStyle: THERMAL_PRINT_PAGE_STYLE,
	})

	async function printTabReport(type, e) {
		e?.stopPropagation?.()
		e?.preventDefault?.()
		if (activeTab !== type) {
			await searchWithFilter(type)
		}
		printWithTime()
	}

	// Время печати фиксируем перед печатью, чтобы в подвале было актуальное
	function printWithTime() {
		setPrintedAt(new Date())
		setTimeout(() => {
			handlePrint()
		}, 350)
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('z_report')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(activeTab)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase">
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="d-flex gap-3">
						<div style={{ 'width': '30%' }}>
							<div className="right" style={{ 'overflow': 'auto' }}>
								{reports.map((item, index) => (
									<div key={index}>
										<div className="d-flex justify-content-between align-items-center mb-2 gap-1"
											style={activeTab === item.value ? { 'borderBottom': '1px solid #000' } : {}}>
											<h6 className="mb-0 flex-grow-1 cursor"
												onClick={() => searchWithFilter(item.value)}>
												{item.name}
											</h6>
											<div className="d-flex align-items-center gap-1" style={{ 'flexShrink': 0 }}>
												<i className="uil uil-file-download-alt text-success"
													style={{ 'cursor': 'pointer', 'fontSize': '16px' }}
													title={t('EXCEL')}
													onClick={(e) => exportTabExcel(item.value, e)}>
												</i>
												<i className="uil uil-print"
													style={{ 'cursor': 'pointer' }}
													title={t('print')}
													onClick={(e) => printTabReport(item.value, e)}>
												</i>
											</div>
										</div>
										{item.value === 'cashiers_x' && activeTab === 'cashiers_x' &&
											<div className="ms-2 mb-2">
												{getCashiersXList().map((cashier, cIndex) => (
													<div
														key={cashier.cashier_login ?? cIndex}
														className="d-flex justify-content-between align-items-center px-2"
														style={{
															'cursor': 'pointer',
															'lineHeight': '1.35',
															'fontSize': '13px',
															'paddingTop': '4px',
															'paddingBottom': '4px',
															...(activeCashierLogin === cashier.cashier_login
																? { 'borderBottom': '1px solid #000' }
																: {}),
														}}
														onClick={() => setActiveCashierLogin(cashier.cashier_login)}
													>
														<div className="d-flex align-items-center gap-2">
															<span>{activeCashierLogin === cashier.cashier_login ? '▾' : '▸'}</span>
															<span>{cashier.cashier_name}</span>
														</div>
														<i className="uil-print"
															style={{ 'cursor': 'pointer', 'flexShrink': 0 }}
															title={t('print')}
															onClick={(e) => {
																e.stopPropagation()
																setActiveCashierLogin(cashier.cashier_login)
																printWithTime()
															}}>
														</i>
													</div>
												))}
											</div>
										}
									</div>
								))}
							</div>
						</div>
						<div id="print" ref={printRef} className="shift-thermal-print"
							style={{ 'width': '70%', 'lineHeight': '15px' }}>
							{activeTab === 'x_report' &&
								<div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('hall')} ]</span>
										<span>{xReportData.x_report.count_hall}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
										<span>{xReportData.x_report.count_takeaway}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
										<span>{xReportData.x_report.count_delivery}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<b>{t('number_of_checks')}</b>
										<b>{xReportData.x_report.count_cheques}</b>
									</div>
									{!!xReportData.x_report.count_deleted_cheques &&
										<>
											<div className="d-flex justify-content-between">
												<p>{t('deleted_cheques')}</p>
												<p>{xReportData.x_report.count_deleted_cheques}</p>
											</div>
											<div className="d-flex justify-content-between">
												<p>{t('deleted_products')}</p>
												<p>{xReportData.x_report.count_deleted_products}</p>
											</div>
										</>
									}
									{(xReportData && xReportData.x_report?.payments?.length > 0) &&
										<hr />
									}
									<div className="d-flex justify-content-between fz14">
										<span>{t('sales')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.sales)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('service')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.service_percentage_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('delivery')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.total_delivery_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<b>{t('sales_amount')}</b>
										<b>{formatMoney(xReportData.x_report?.total_sales)}</b>
									</div>
									<div className="ms-2">
										<div className="d-flex justify-content-between d-none">
											<p>{t('change')}</p>
											<p className="text-success">{formatMoney(xReportData.x_report?.total_change)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<p>{t('discount')}</p>
											<p className="text-danger">{formatMoney(xReportData.x_report?.total_discount)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<span>{t('debt')}</span>
											<span className="text-danger">{formatMoney(xReportData.x_report.total_debt_amount)}</span>
										</div>
										{xReportData.x_report.loyalty &&
											<div className="d-flex justify-content-between">
												<span>{t('loyalty')}</span>
												<span className="text-danger">{formatMoney(xReportData.x_report?.loyalty)}</span>
											</div>
										}
										<div className="d-flex justify-content-between">
											<b>
												<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')}`)}>
													{t('total')}
												</CustomTooltip>
											</b>
											<b className="text-danger">
												{formatMoney(
													Number(xReportData.x_report.total_discount) +
													Number(xReportData.x_report.total_debt_amount)
												)}
											</b>
										</div>
									</div>
									{!!xReportData.x_report?.total_return_debt &&
										<div className="d-flex justify-content-between fz14">
											<b>
												<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')}`)}>
													{t('total_checkout_sales')}
												</CustomTooltip>
											</b>
											<b>{formatMoney(xReportData.x_report?.total_payments - xReportData.x_report?.total_return_debt)}</b>
										</div>
									}
									<div className="d-flex justify-content-between fz14">
										<b>
											<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
												{t('total_checkout')}
											</CustomTooltip>
										</b>
										<b>{formatMoney(xReportData.x_report?.total_payments)}</b>
									</div>
									<div className="ms-2">
										{xReportData.x_report?.payments?.map((item, index) => (
											<div key={index} className="d-flex justify-content-between bg-hover-gray"
												style={{ 'borderBottom': '1px solid var(--dark-border, #eee)' }}>
												<p className="d-flex flex-wrap gap-1">
													{item.transaction_type === 'plus' ?
														<span>&#9660;</span>
														:
														<span>&#9650;</span>
													}
													<span>{item.payment_type_name}</span>
													<span>{item.payment_purpose_name}</span>
												</p>
												{item.transaction_type === 'plus' ?
													<p className="text-success text-nowrap">{formatMoney(item.amount)}</p>
													:
													<p className="text-danger text-nowrap">{formatMoney(item.amount)}</p>
												}
											</div>
										))}
										{!!xReportData.x_report.total_cash &&
											<div className="d-flex justify-content-between">
												<b>{t('total_cash')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_cash)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_bank &&
											<div className="d-flex justify-content-between">
												<b>{t('total_bank')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_bank)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_expense &&
											<div className="d-flex justify-content-between">
												<b>{t('total_expense')}</b>
												<b className="text-danger">
													{formatMoney(xReportData.x_report.total_expense)}
												</b>
											</div>
										}
									</div>
									<hr />
									<b className="d-flex justify-content-between">
										<h5 className="color-00">
											<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} + ${t('debt_returned')} - ${t('expenses')}`)}>
												{t('cashbox_balance')}
											</CustomTooltip>
										</h5>
										<h5 className="text-no-wrap color-00">
											{formatMoney(xReportData.x_report.balance)}
										</h5>
									</b>
								</div>
							}
							{activeTab === 'menus' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{renderMenuTreeRows(xReportData?.menus?.data)}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-start"><b>{t('product')}</b></th>
												<th className="text-end text-nowrap"><b>{t('quantity')}</b></th>
												<th className="text-end text-nowrap"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.products?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.menu_name}</td>
													<td className="text-start">{item.name}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'preparation_places' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('preparation_places')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.preparation_places?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'deleted_cheques' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('cashier')}</b>
													</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('waiter')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '20%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end"
														style={{ 'width': '20%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['deleted_cheques']?.data?.map((item, index) => (
													<tr key={index}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-center">{index + 1}</td>
														<td className="text-start td-ellipsis">
															{item.cashier_name}
														</td>
														<td className="text-start td-ellipsis">
															{item.waiter_name}
														</td>
														<td className="text-center">
															{formatDate(item.cheque_closed_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_amount)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td></td>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_cheques.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'discount_cheques' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('cashier')}</b>
													</th>
													<th className="text-start"
														style={{ 'width': '25%' }}>
														<b>{t('waiter')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '15%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end"
														style={{ 'width': '12%' }}>
														<b>{t('discount')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '13%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['discount_cheques']?.data?.map((item, index) => (
													<tr key={index}
														style={{ 'cursor': 'pointer' }}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-center">{index + 1}</td>
														<td className="text-start td-ellipsis">
															{item.cashier_name}
														</td>
														<td className="text-start td-ellipsis">
															{item.waiter_name}
														</td>
														<td className="text-center">
															{formatDate(item.cheque_closed_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis text-danger">
															{formatMoney(item.discount)}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_amount)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td></td>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td className="text-end text-danger">
														<b>{formatMoney(xReportData.discount_cheques?.total_discount)}</b>
													</td>
													<td className="text-end">
														<b>{formatMoney(xReportData.discount_cheques?.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'deleted_products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th className="text-start"
														style={{ 'width': '30%' }}>
														<b>{t('name2')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '20%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end text-nowrap"
														style={{ 'width': '20%' }}>
														<b>{t('quantity')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '20%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['deleted_products']?.data?.map((item, index) => (
													<tr key={index}
														onClick={() => toggleRightbar(true, item)}>
														<td className="text-start td-ellipsis">
															{item.name}
														</td>
														<td className="text-center">
															{formatDate(item.created_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis">
															{item.quantity}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_price)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_quantity)}</b>
													</td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'order_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('order_type')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.order_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'order_sub_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('delivery_type')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.order_sub_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'payment_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('name2')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.payment_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'expenses' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '40%' }}><b>{t('type')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('counterparty')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('note')}</b>
												</th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b>
												</th>
											</tr>
										</thead>
										<tbody>
											{xReportData['expenses']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis" title={item.counterparty}>
														{item.counterparty}
													</td>
													<td className="text-start td-ellipsis" title={item.note}>
														{item.note}
													</td>
													<td className="text-end text-nowrap">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.expenses.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'incomes' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '50%' }}><b>{t('type')}</b></th>
												<th className="text-start"
													style={{ 'width': '30%' }}><b>{t('counterparty')}</b></th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['incomes']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis">
														{item.counterparty}
													</td>
													<td className="text-end">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.incomes.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'debtors' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom mb-2">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-start"><b>{t('counterparty')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['debtors']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{returnEntityType(item)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.debtors.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'clients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.clients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiters' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('waiter')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('service')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.waiters?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_service_amount)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_service_amount)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiter_menus' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									{xReportData?.waiter_menus?.data?.map((waiter, wIndex) => (
										<div className="mb-3" key={wIndex}>
											<table className="table table-bordered table-bordered-custom">
												<thead>
													<tr>
														<th style={{ 'width': '50%' }} className="text-start"><b>{waiter.name}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('quantity')}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('amount')}</b></th>
													</tr>
												</thead>
												<tbody>
													{renderMenuTreeRows(waiter?.groups, 2)}
												</tbody>
												<tfoot>
													<tr>
														<td><b>{t('total')}</b></td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_quantity, 2)}</b>
														</td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_amount)}</b>
														</td>
													</tr>
												</tfoot>
											</table>
										</div>
									))}
								</div>
							}
							{activeTab === 'waiter_products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									{xReportData?.waiter_products?.data?.map((waiter, wIndex) => (
										<div className="mb-3" key={wIndex}>
											<table className="table table-bordered table-bordered-custom">
												<thead>
													<tr>
														<th style={{ 'width': '50%' }} className="text-start"><b>{waiter.name}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('quantity')}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('amount')}</b></th>
													</tr>
												</thead>
												<tbody>
													{waiter?.products?.map((item, index) => (
														<tr key={index}>
															<td className="text-start">{item.name}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
														</tr>
													))}
												</tbody>
												<tfoot>
													<tr>
														<td><b>{t('total')}</b></td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_quantity)}</b>
														</td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_amount)}</b>
														</td>
													</tr>
												</tfoot>
											</table>
										</div>
									))}
								</div>
							}
							{activeTab === 'motivation_programs' &&
								<MotivationProgramsTable payload={xReportData?.motivation_programs} />
							}
							{activeTab === 'cashiers' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('cashier')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.cashiers?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'cashiers_x' && getActiveCashierX() &&
								(() => {
									const item = getActiveCashierX()
									return (
										<div style={{ 'height': '500px', 'overflow': 'auto' }}>
											<div className="d-flex justify-content-between mb-1">
												<span>{t('pos')}</span>
												<span>{item.pos_name}</span>
											</div>
											{!!item.cashbox_name &&
												<div className="d-flex justify-content-between mb-1">
													<span>{t('cashbox')}</span>
													<span>{item.cashbox_name}</span>
												</div>
											}
											{!!item.shift_id &&
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift')} ID</span>
													<span>{item.shift_id}</span>
												</div>
											}
											{!!item.shift_number &&
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift_number')}</span>
													<span>{item.shift_number}</span>
												</div>
											}
											<div className="d-flex justify-content-between mb-1">
												<span>{t('cashier')}</span>
												<span>{item.cashier_name}</span>
											</div>
											<div className="d-flex justify-content-between mb-1">
												<span>{t('period')}</span>
												<span>
													{formatDate(item.opened_at, 'dd.MM.yy')}
													{' — '}
													{formatDate(item.closed_at, 'dd.MM.yy')}
												</span>
											</div>
											<hr />
											<div className="d-flex justify-content-between mb-1">
												<span>{t('number_of_checks')} [ {t('hall')} ]</span>
												<span>{item.count_hall}</span>
											</div>
											<div className="d-flex justify-content-between mb-1">
												<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
												<span>{item.count_takeaway}</span>
											</div>
											<div className="d-flex justify-content-between mb-1">
												<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
												<span>{item.count_delivery}</span>
											</div>
											<div className="d-flex justify-content-between mb-1">
												<b>{t('number_of_checks')}</b>
												<b>{item.count_cheques}</b>
											</div>
											{!!item.count_deleted_cheques &&
												<>
													<div className="d-flex justify-content-between">
														<p>{t('deleted_cheques')}</p>
														<p>{item.count_deleted_cheques}</p>
													</div>
													<div className="d-flex justify-content-between">
														<p>{t('deleted_products')}</p>
														<p>{item.count_deleted_products}</p>
													</div>
												</>
											}
											{(item?.payments?.length > 0) &&
												<hr />
											}
											<div className="d-flex justify-content-between fz14">
												<span>{t('sales')}</span>
												<span className="text-success">{formatMoney(item?.sales)}</span>
											</div>
											<div className="d-flex justify-content-between fz14">
												<span>{t('service')}</span>
												<span className="text-success">{formatMoney(item?.service_percentage_amount)}</span>
											</div>
											<div className="d-flex justify-content-between fz14">
												<span>{t('delivery')}</span>
												<span className="text-success">{formatMoney(item?.total_delivery_amount)}</span>
											</div>
											<div className="d-flex justify-content-between fz14">
												<b>{t('sales_amount')}</b>
												<b>{formatMoney(item?.total_sales)}</b>
											</div>
											<div className="ms-2">
												<div className="d-flex justify-content-between">
													<p>{t('discount')}</p>
													<p className="text-danger">{formatMoney(item?.total_discount)}</p>
												</div>
												<div className="d-flex justify-content-between">
													<span>{t('debt')}</span>
													<span className="text-danger">{formatMoney(item.total_debt_amount)}</span>
												</div>
												{item.loyalty &&
													<div className="d-flex justify-content-between">
														<span>{t('loyalty')}</span>
														<span className="text-danger">{formatMoney(item?.loyalty)}</span>
													</div>
												}
												<div className="d-flex justify-content-between">
													<b>
														<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')}`)}>
															{t('total')}
														</CustomTooltip>
													</b>
													<b className="text-danger">
														{formatMoney(
															Number(item.total_discount) +
															Number(item.total_debt_amount)
														)}
													</b>
												</div>
											</div>
											<div className="d-flex justify-content-between fz14">
												<b>
													<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
														{t('total_checkout')}
													</CustomTooltip>
												</b>
												<b>{formatMoney(item?.total_payments)}</b>
											</div>
											<div className="ms-2">
												{item?.payments?.map((payment, paymentIndex) => (
													<div key={paymentIndex} className="d-flex justify-content-between bg-hover-gray"
														style={{ 'borderBottom': '1px solid var(--dark-border, #eee)' }}>
														<p className="d-flex flex-wrap gap-1">
															{payment.transaction_type === 'plus' ?
																<span>&#9660;</span>
																:
																<span>&#9650;</span>
															}
															<span>{payment.payment_type_name}</span>
															<span>{payment.payment_purpose_name}</span>
														</p>
														{payment.transaction_type === 'plus' ?
															<p className="text-success text-nowrap">{formatMoney(payment.amount)}</p>
															:
															<p className="text-danger text-nowrap">{formatMoney(payment.amount)}</p>
														}
													</div>
												))}
												{!!item.total_cash &&
													<div className="d-flex justify-content-between">
														<b>{t('total_cash')}</b>
														<b className="text-success">
															{formatMoney(item.total_cash)}
														</b>
													</div>
												}
												{!!item.total_bank &&
													<div className="d-flex justify-content-between">
														<b>{t('total_bank')}</b>
														<b className="text-success">
															{formatMoney(item.total_bank)}
														</b>
													</div>
												}
												{!!item.total_expense &&
													<div className="d-flex justify-content-between">
														<b>{t('total_expense')}</b>
														<b className="text-danger">
															{formatMoney(item.total_expense)}
														</b>
													</div>
												}
											</div>
											<hr />
											<b className="d-flex justify-content-between">
												<h5 className="color-00">
													<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} + ${t('debt_returned')} - ${t('expenses')}`)}>
														{t('cashbox_balance')}
													</CustomTooltip>
												</h5>
												<h5 className="text-no-wrap color-00">
													{formatMoney(item.balance)}
												</h5>
											</b>
										</div>
									)
								})()
							}
							{activeTab === 'couriers' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('courier')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.couriers?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.couriers.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.couriers.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'ingredients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-center" style={{ 'width': '33px' }}><b>#</b></th>
												<th className="text-start"><b>{t('element')}</b></th>
												<th className="text-start"><b>{t('category')}</b></th>
												<th className="text-start"><b>{t('unit')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.ingredients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-center">{index + 1}</td>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{item.category_name}</td>
													<td className="text-start">{item.unit_name}</td>
													<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.ingredients.total_quantity, 2)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products_ingredients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-center" style={{ 'width': '33px' }}><b>#</b></th>
												<th className="text-start"><b>{t('product')}</b></th>
												<th className="text-start"><b>{t('category')}</b></th>
												<th className="text-start"><b>{t('unit')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											<TreeTable
												data={xReportData.products_ingredients?.data}
												formatMoney={formatMoney}
											/>
										</tbody>
									</table>
								</div>
							}
							{/* Подвал только для печати: период из фильтра, точка и время печати */}
							<div className="d-none d-print-block mt-3 pt-2" style={{ 'borderTop': '1px dashed #000' }}>
								{(filterData.start_date || filterData.end_date) &&
									<div className="d-flex justify-content-between mb-1">
										<span>{t('period')}</span>
										<span>
											{formatDate(filterData.start_date)}
											{(filterData.end_date && filterData.end_date !== filterData.start_date) &&
												<> - {formatDate(filterData.end_date)}</>
											}
										</span>
									</div>
								}
								{filterData.pos_id &&
									<div className="d-flex justify-content-between mb-1">
										<span>{t('pos')}</span>
										<span className="text-end">{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}</span>
									</div>
								}
								<div className="d-flex justify-content-between mb-1">
									<span>{t('printed_at')}</span>
									<span>{formatDate(printedAt || new Date(), 'dd.MM.yyyy HH:mm')}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>
		</>
	)
}

export default Index
